import "./travelCard.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const TravelCard = ({ data }) => {
    const { t } = useTranslation();

    return (
        <div className="container-fluid px-md-5 mx-md-0 mx-2 mb-3">
            <div className="travel-card">
                <div className="row g-0">
                    {/* Left Content */}
                    <div className="col-md-9">
                        <div className="travel-card-header">
                            <Link to="/" className="text-muted" title="Go back to previous page">
                                <i className="bi bi-arrow-left text-dark fs-5"></i>
                            </Link>
                            <span className="text-muted">{t("youAreTravelingFrom")} </span>
                            <strong>{t("oman")}</strong>
                            <span className="mx-2 text-primary">
                                <i className="bi bi-airplane text-dark" style={{ transform: "rotate(45deg)" }}></i>
                            </span>
                            <strong>{data?.destination || "N/A"}</strong>

                        </div>
                        <div className="travel-card-body d-flex flex-wrap align-items-center">
                            <div className="info-item d-flex align-items-center">
                                <i className="bi bi-calendar travel-icon"></i>
                                <span>{data?.arab_oriene_start_date || "N/A"} - {data?.arab_oriene_end_date || "N/A"}</span>
                            </div>
                            <div className="info-item d-flex align-items-center">
                                <i className="bi bi-clock travel-icon"></i>
                                <span>{data?.no_of_days || "N/A"} {t("days")}</span>
                            </div>
                            <div className="info-item d-flex align-items-center">
                                <i className="bi bi-person travel-icon"></i>
                                <span>{data?.total_adults + data?.total_children} {t("passenger")}</span>
                            </div>
                        </div>
                    </div>

                    {/* Right Image */}
                    <div className="col-md-3 d-flex align-items-center justify-content-center bg-body-tertiary">
                        <i className="bi bi-airplane custom-airplane-style" ></i>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TravelCard;
